import {type EmptyObject} from '~/utils/types'
import {Method, SimpleAPI} from '../../SimpleAPI'

export type AnonymousUserEmailParams = {
  email: string
  location: string
}

export class FEMAnonymousUserEmail extends SimpleAPI<
  EmptyObject,
  AnonymousUserEmailParams
> {
  revalidate = 'client-only' as const
  method = Method.POST

  getPath() {
    return '/fem/anonymous-user-email'
  }

  protected async getMockResponse() {
    return {}
  }
}
